export const testSpecificLocation = [
  {
    location: 'mahmoud 21 test',
    address: 'Montreal Quebec',
    specificLocation: {
      ['mahmoud test 1']: {
        numOfSSR: 4,
        numOfUOS: 1,
        switchInfo: [
          {
            UOS: '01',
            application: 'ST',
            deviceMac: 'f0b46b54-f09c-49df-9cad-f70420d5083a',
            deviceName: 'MA #20 ST ess',
            displaySelectBox: [false, false, false, false, false],
            gasType: null,
            heatingSys: 'ess',
            latitude: 45.5018869,
            longitude: -73.56739189999999,
            selectedSSR: [
              {
                ssr1: {
                  isSelectSwitchListOpen: false,
                  specs: [],
                  thermoCouple: 'tc-01',
                },
              },
              {
                ssr2: {
                  isSelectSwitchListOpen: false,
                  specs: [],
                  thermoCouple: 'tc-01',
                },
              },
            ],
            ssrRating: '40 amps',
            switchName: 'MA',
            switchSize: '#20',
            sysId: '152878931',
            type: 'switch',
            zoneId: 'ed98b2a4-c2ff-49fe-af62-9bef2fe46805',
          },
        ],
        switchesNum: 1,
      },
      ['mahmoud test 2']: {
        numOfSSR: 4,
        numOfUOS: 1,
        switchInfo: [
          {
            UOS: '01',
            application: 'ST',
            deviceMac: 'f0b46b54-f09c-49df-9cad-f70420d5083a',
            deviceName: 'MA #20 ST ess',
            displaySelectBox: [false, false, false, false, false],
            gasType: null,
            heatingSys: 'ess',
            latitude: 45.5018869,
            longitude: -73.56739189999999,
            selectedSSR: [
              {
                ssr1: {
                  isSelectSwitchListOpen: false,
                  specs: [],
                  thermoCouple: 'tc-01',
                },
              },
              {
                ssr2: {
                  isSelectSwitchListOpen: false,
                  specs: [],
                  thermoCouple: 'tc-01',
                },
              },
            ],
            ssrRating: '40 amps',
            switchName: 'MA',
            switchSize: '#20',
            sysId: '152878931',
            type: 'switch',
            zoneId: 'ed98b2a4-c2ff-49fe-af62-9bef2fe46805',
          },
        ],
        switchesNum: 1,
      },
    },
    specificLocationList: ['mahmoud test', 'mahmoud test 2'],
  },
];
